module.exports = __webpack_public_path__ + "img/diamondparticle.b143b058.png";